module.exports = __webpack_public_path__ + "static/media/la.635b3d0b.svg";